import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { httpPost } from "../../../../utility/requestHelper";
import { FilterCloseIcon } from "../../../Icons/icons.component";
import { unifiedEnvConfig } from "../../../../constants/api-endpoint";
import Loader from "../../../Shared/Loader";
import { APP_CONSTANTS } from "../../../../constants/app-constant";

export const TagsListModal = function ({
  show,
  onCancel,
  confirmButtonText,
  feedDetail,
  addedTag,
  onBulkUpdate,
}) {
  const clientState =
    useSelector(
      (state) => state.clientReducer) || {};

  const [isSelected, setSelected] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);
  const [addButtonLoader, setAddButtonLoader] = useState(false);

  const { selectedClient, feedTagList } = clientState;

  useEffect(() => {
    if (feedTagList) {
      const { data, isLoading, error } = feedTagList;
      if (isLoading) {
        setLoader(true);
      }
      else if (error) {
        setError(error);
      }
      else {
        setTagsList(data)
      }
    }
  }, [feedTagList]);

  const selectTag = (
    checked,
    { id, name, social_count, blog_count, forum_count, created_at, updated_at }
  ) => {
    setError(null);
    setSelected(checked);

    if (checked) {
      setSelectedList([
        ...selectedList,
        {
          id,
          name,
          social_count,
          blog_count,
          forum_count,
        },
      ]);
    } else {
      setSelectedList(selectedList.filter((n) => n.id != id));
    }
  };

  const formatPostData = (tagsList) => {
    return {
      updateByFilter: false,
      tag_ids: tagsList.map((tag) => tag.id),
      feeds: tagsList.map(() => {
        return {
          social_feed_id: feedDetail && feedDetail.id ? feedDetail.id : "",
          channel_type:
            feedDetail && feedDetail.channel_type
              ? feedDetail.channel_type
              : "",
        };
      }),
    };
  };

  const handleAddClick = () => {
    setError("");
    if (onBulkUpdate && typeof onBulkUpdate == "function") {
      setAddButtonLoader(true);
      onBulkUpdate(selectedList)
        .then(() => setAddButtonLoader(false))
        .catch(() => setAddButtonLoader(true));
    } else if (feedDetail && feedDetail.id && selectedList) {
      setAddButtonLoader(true);
      httpPost(
        `${unifiedEnvConfig.ADD_TAG_TO_FEED}?client_id=${selectedClient.id}`,
        formatPostData(selectedList),
        {},
        true
      )
        .then(() => {
          setAddButtonLoader(false);
          onCancel(false);
          addedTag(
            selectedList.map((item) => {
              return {
                tag_id: item.id,
                tag_name: item.name,
              };
            })
          );
        })
        .catch((error) => {
          if (error.message == APP_CONSTANTS.API_CANCEL_ERROR_TEXT) {
            setAddButtonLoader(true);
            setError("");
          } else if (error.response && error.response.data) {
            setAddButtonLoader(false);
            const { status } = error.response.data;
            if (status === 409) {
              setError("Tag already exist to this feed.");
            } else {
              setError("Error Occurred. Please try again.");
            }
          } else {
            setError("Error Occurred. Please try again.");
          }
        });
    } else {
      setError("Please select a tag or try again.");
    }
  };

  const disableSubmit = !selectedList.length || addButtonLoader;

  return (
    <Modal
      show={show}
      onHide={onCancel}
      backdrop="static"
      keyboard={false}
      className="customModalWrap"
      dialogClassName="addTagListModal"
    >
      <Modal.Header>
        {!loader ? (
          <>
            <Modal.Title>Add Tag</Modal.Title>
            <button className="btnModalClose" onClick={() => onCancel(false)}>
              <FilterCloseIcon />
            </button>
          </>
        ) : null}
      </Modal.Header>
      {loader ? (
        <Loader />
      ) : (
        <>
          <Modal.Body>
            <ul className="tagListing">
              {tagsList && tagsList.length
                ? tagsList.map((tag) => (
                  <>
                    <li key={tag.id}>
                      <label className="inputWrap">
                        {tag.name}
                        <input
                          type="checkbox"
                          className="styled-checkbox"
                          isChecked={isSelected}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => selectTag(e.target.checked, tag)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </li>
                  </>
                ))
                : null}
            </ul>
          </Modal.Body>
          <Modal.Footer>
            <div className="btnWithMessage">
              {error && <p className="text-danger">{error}</p>}
              <Button
                variant="primary"
                onClick={(e) => handleAddClick()}
                className="btn btnBlue"
                disabled={disableSubmit}
              >
                {confirmButtonText}
              </Button>
            </div>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

TagsListModal.defaultProps = {
  show: false,
  onConfirm: () => { },
  onCancel: () => { },
  confirmButtonText: "Add",
  confirmText: "",
  modalTitle: "Add Tag",
  cancelButtonText: "Cancel",
};
